import MatAutocomplete from "@material-ui/lab/Autocomplete";
import { useFormContext } from "components/Form";
import { Input } from "components/Input";
import { ReactNode } from "react";
import { Controller } from "react-hook-form";

interface AutoCompleteProps {
  name: string;
  propertyLabel: string;
  label?: ReactNode;
  customLabel?: string;
  options: any[];
  error?: boolean;
  helperText?: string;
  defaultValue?: string;
}

export function AutoComplete({
  options = [],
  name,
  propertyLabel,
  customLabel,
  error,
  helperText,
  defaultValue,
}: AutoCompleteProps) {
  const {
    methodsForm: { control },
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={options.find((option) => option.value === defaultValue)}
      render={({ field }) => {
        const { ref, value, onChange, ...fieldProps } = field;
        return (
          <MatAutocomplete
            options={options}
            noOptionsText="Nenhuma opção disponível"
            getOptionLabel={(option) => option[propertyLabel]}
            renderInput={(params) => (
              <Input
                {...params}
                customLabel={customLabel}
                error={error}
                helperText={helperText}
              />
            )}
            value={value || null}
            onChange={(e, data) =>
              data ? onChange(data) : onChange(undefined)
            }
            {...fieldProps}
          />
        );
      }}
    />
  );
}
